import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policy-it',
  templateUrl: './it.component.html',
  styleUrl: './it.component.scss'
})
export class PrivacyPolicyItComponent {

}
